import React from 'react';
import PropTypes from 'prop-types';
import CybsButton from '@cybs-ui/components/lib/button';
import { css } from '@emotion/core';

const Link = ({
  dataTest,
  value,
  cell,
  colIdx,
  rowIdx,
  onClick,
  width,
  ariaLabel,
  href,
  style
}) => {
  const handleClick = e => onClick(null, cell, rowIdx, colIdx, e);
  return value && (
    <div
      css={css`
        a {
          word-break: break-word;
          display: block !important;
        }
      `}
    >
      <CybsButton
        colorScheme="secondary"
        dataTest={dataTest}
        data-innerfocus
        i18n={{ label: value, ariaLabel }}
        key={`${dataTest}-${rowIdx}`}
        onClick={handleClick}
        variant="link"
        tag="a"
        href={href}
        width={width}
        style={style}
      />
    </div>
  );
};

Link.displayName = 'Link';
Link.defaultProps = {
  dataTest: '',
  value: '',
  href: '',
  rowIdx: 0,
  cell: {},
  colIdx: 0,
  width: '100%',
  onClick: () => null,
  ariaLabel: '',
  style: undefined
};

Link.propTypes = {
  cell: PropTypes.object, // eslint-disable-line
  dataTest: PropTypes.string,
  value: PropTypes.string,
  href: PropTypes.string,
  rowIdx: PropTypes.number,
  colIdx: PropTypes.number,
  onClick: PropTypes.func,
  width: PropTypes.string,
  ariaLabel: PropTypes.string,
  style: PropTypes.func
};

export default Link;
